var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{class:_vm.cssClass,style:(_vm.makeStyle({ variant: _vm.variant, contained: _vm.contained })),attrs:{"color":_vm.color,"size":_vm.size,"outlined":_vm.outlined,"rounded":_vm.rounded,"disabled":_vm.disabled,"text":_vm.text,"elevation":0},on:{"click":function (e) { return this$1.$emit('click',e); }}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }